import { render, staticRenderFns } from "./DailyChallenge.vue?vue&type=template&id=74cc1c28&scoped=true&"
import script from "./DailyChallenge.vue?vue&type=script&lang=ts&"
export * from "./DailyChallenge.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallenge.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DailyChallenge.vue?vue&type=style&index=1&id=74cc1c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cc1c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('74cc1c28', component.options)
    } else {
      api.reload('74cc1c28', component.options)
    }
    module.hot.accept("./DailyChallenge.vue?vue&type=template&id=74cc1c28&scoped=true&", function () {
      api.rerender('74cc1c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/DailyChallenge.vue"
export default component.exports